import React from 'react';
import { connect } from 'react-redux';
import PieChart from '../../../Charts/PieChart';
import * as actions from '../../../../store/actions/index';

const PieGastosDelMesPorEmpresa = (props) => {
  
  const handlePorcionClick = (config) => {
    props.onPorcionClick(config);
  };

  return (
    <PieChart
      title={props.title}
      subTitle={props.subtitle}
      series={props.gastos.map((gasto) => gasto.total)}
      labels={props.gastos.map((gasto) => gasto.nombreEmpresa)}
      ids={props.gastos.map((gasto) => gasto.id)}
      imgSinDatos={props.totalGastos <= 0}
      loading={props.loading}
      chartType={'pie'}
      height={props.height}
      disabled={props.estaOculto}
      width={'100%'}
      onPorcionClick={handlePorcionClick}
      onChangeViewClick={props.onChangeViewClick}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    gastos: state.multiempresa.gastosDelMesPorEmpresa.gastos,
    loading: state.multiempresa.gastosDelMesPorEmpresa.loading,
    estaCargado: state.multiempresa.gastosDelMesPorEmpresa.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.gastosDelMesMultiempresa
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: () => dispatch(actions.loadGastosDelMesPorEmpresa())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PieGastosDelMesPorEmpresa);
